import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/system";
import RemoveIcon from "@mui/icons-material/Remove";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import { CircularProgress } from "@mui/material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function StaffCourseOffering({ sID }) {
  let api = useAxiosPrivate();

  let [offerings, setOfferings] = React.useState([]);
  let [noOfferings, setNoofferings] = React.useState(false);
  let [loading, setLoading] = React.useState(false);
  let [isMounted, setIsMounted] = React.useState(true);

  async function getStaffOffering(signal) {
    setLoading(true);

    let resp = await api.get(
      `courseallocation/allocation/courseOfferingforstafftable?staffId=${sID}`,
      {
        signal,
      }
    );
    let respdata = resp.data;

    isMounted && setOfferings(respdata);
    isMounted && setLoading(false);
  }

  React.useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();
    getStaffOffering(controller.signal);

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);

  React.useEffect(() => {
    if (offerings.length <= 0 == true) {
      setNoofferings(true);
    }
  }, [offerings]);

  return (
    <React.Fragment>
      {offerings.length >= 1 == true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TableContainer
            sx={{
              border: 2,
              borderColor: "#cd853f",
              minWidth: 500,
              width: 510,
              marginBottom: 4,
            }}
          >
            <Table
              sx={{ minWidth: 500, border: 0, width: 500 }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", fontSize: 16 }}>
                    Priority
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{ fontWeight: "bold", fontSize: 16 }}
                  >
                    Course Name
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bold", fontSize: 16 }}
                  >
                    {" "}
                    Course Code
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {offerings.map((offering, index) => (
                  <TableRow key={index} sx={{ border: 0 }}>
                    <TableCell component="th" scope="row">
                      {offering.priority}st
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ fontWeight: "bold", fontSize: 16 }}
                    >
                      {offering.course.course_name}
                    </TableCell>
                    <TableCell align="center">
                      {offering.course.course_code}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {loading == false && (
            <h3 style={{ textAlign: "center" }}>
              Course Offering Not Submitted By Staff
            </h3>
          )}
          {loading == true && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </div>
      )}
    </React.Fragment>
  );
}

export default StaffCourseOffering;
